// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student_dashboard_sidebar-component .student-user-info {\n  margin-bottom: 1.3rem; }\n\n.student_dashboard_sidebar-component .student-my-courses {\n  margin-bottom: 1.3rem; }\n\n.student_dashboard_sidebar-component .student-activity-calendar {\n  margin-bottom: 1.3rem; }\n\n@media screen and (max-width: 991px) {\n  .student_dashboard_sidebar-component .student-activity-calendar {\n    display: none; } }\n", ""]);
// Exports
module.exports = exports;
